<span class="reportable-receipts-title label-medium-emphasized">
  {{ 'receipts.ui.elencoBrogliacciDaVersare' | transloco }}
</span>

@if (isLoading) {
  <ui-loading-spinner></ui-loading-spinner>
} @else if (brogliacciAssociabili.length === 0) {
  <span class="reportable-receipts-empty body-medium">
    {{ 'receipts.ui.nessunBrogliaccioAssociabile' | transloco }}
  </span>
} @else {

<div class="reportable-receipts-desktop">
  <div class="reportable-receipts-table-container">
    <table
      mat-table
      [dataSource]="brogliacciAssociabili"
      class="reportable-receipts-table"
    >
      <ng-container matColumnDef="numeroBrogliaccio">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.nBrogliaccio' | transloco }}</th>
        <td mat-cell *matCellDef="let brogliaccio">{{ brogliaccio.numeroBrogliaccio }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.data' | transloco }}</th>
        <td mat-cell *matCellDef="let brogliaccio">
          {{ brogliaccio.data | date:'dd/MM/yyyy' }}
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span class="body-medium-emphasized">{{ 'receipts.ui.totali' | transloco }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="numeroIncassi">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.incassi' | transloco }}</th>
        <td mat-cell *matCellDef="let brogliaccio">{{ brogliaccio.numeroIncassi }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="importoContanti">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.contanti' | transloco }}</th>
        <td mat-cell *matCellDef="let brogliaccio" class="currency-cell">
          {{ brogliaccio.importoContanti | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleContantiSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoAssegni">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.assegni' | transloco }}</th>
        <td mat-cell *matCellDef="let brogliaccio" class="currency-cell">
          {{ brogliaccio.importoAssegni | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleAssegniSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoTotale">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.totale2' | transloco }}</th>
        <td mat-cell *matCellDef="let brogliaccio" class="currency-cell">
          {{ brogliaccio.importoTotale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleBrogliacciSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="selezionato">
        <th mat-header-cell *matHeaderCellDef class="checkbox-cell">
          <mat-checkbox
            [checked]="tuttiInclusi"
            [indeterminate]="selezioneParziale"
            [attr.aria-label]="'receipts.ui.includiTuttiIBrogliacci' | transloco"
            (change)="impostaTuttiInclusi($event.checked)"
          />
        </th>
        <td mat-cell *matCellDef="let brogliaccio" class="checkbox-cell">
          <mat-checkbox
            [checked]="brogliaccio.selezionato"
            [attr.aria-label]="(('receipts.ui.includiBrogliaccio' | transloco) + ' ') + brogliaccio.numeroBrogliaccio"
            (change)="impostaBrogliaccioIncluso(brogliaccio.id, $event.checked)"
          />
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colonneTabella"></tr>
      <tr mat-row *matRowDef="let row; columns: colonneTabella"></tr>
      <tr mat-footer-row *matFooterRowDef="colonneTabella"></tr>
    </table>
  </div>

  <div class="desktop-draft-actions">
    <button
      matButton="filled"
      type="button"
      class="desktop-action-button desktop-action-button--wide"
      *uiCan="CAPS.distintaCrea"
      [disabled]="!almenoUnBrogliaccioIncluso || isSaving"
      (click)="creaDistinta()"
    >
      {{ 'receipts.ui.creaDistinta' | transloco }}
    </button>

    <button
      matButton="outlined"
      type="button"
      class="desktop-action-button desktop-action-button--exit"
      (click)="tornaIndietro()"
    >
      {{ 'receipts.ui.esci' | transloco }}
    </button>
  </div>
</div>

<div class="reportable-receipts-content">
  <div class="include-all-row">
    <div class="include-all-checkbox-container">
      <mat-checkbox
        class="include-all-checkbox"
        [checked]="tuttiInclusi"
        [indeterminate]="selezioneParziale"
        (change)="impostaTuttiInclusi($event.checked)"
      >
        {{ 'receipts.ui.includiTutti' | transloco }}
      </mat-checkbox>
    </div>
  </div>

  <div class="reportable-receipts-list">
    @for (brogliaccio of brogliacciAssociabili; track brogliaccio.id) {
      <div class="reportable-receipt-card">
        <div class="reportable-receipt-data">
          <div class="receipt-checkbox-container">
            <mat-checkbox
              [checked]="brogliaccio.selezionato"
              [attr.aria-label]="(('receipts.ui.includiBrogliaccio' | transloco) + ' ') + brogliaccio.numeroBrogliaccio"
              (change)="impostaBrogliaccioIncluso(brogliaccio.id, $event.checked)"
            />
          </div>
          <div class="reportable-receipt-info">
            <div class="receipt-info-first-row">
              <div class="receipt-info-pair">
                <span class="body-small">{{ 'receipts.ui.nBrogliaccio2' | transloco }}</span>
                <span class="body-medium-emphasized">{{ brogliaccio.numeroBrogliaccio }}</span>
              </div>

              <div class="receipt-info-pair">
                <span class="body-small">{{ 'receipts.ui.incassi2' | transloco }}</span>
                <span class="body-medium-emphasized">{{ brogliaccio.numeroIncassi }}</span>
              </div>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">{{ 'receipts.ui.data3' | transloco }}</span>
              <span class="body-medium-emphasized">
                {{ brogliaccio.data | date:'dd/MM/yyyy' }}
              </span>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">{{ 'receipts.ui.contanti2' | transloco }}</span>
              <span class="body-medium-emphasized">
                {{ brogliaccio.importoContanti | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">{{ 'receipts.ui.assegni2' | transloco }}</span>
              <span class="body-medium-emphasized">
                {{ brogliaccio.importoAssegni | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">{{ 'receipts.ui.totale3' | transloco }}</span>
              <span class="body-medium-emphasized">
                {{ brogliaccio.importoTotale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<div class="selected-receipts-summary">
  <div class="selected-receipts-summary-top">
    <div class="selected-receipts-summary-row">
      <span class="body-small">{{ 'receipts.ui.totaleContanti3' | transloco }}</span>
      <span class="body-small-emphasized">
        {{ totaleContantiSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
      </span>
    </div>

    <div class="selected-receipts-summary-row">
      <span class="body-small">{{ 'receipts.ui.totaleAssegni3' | transloco }}</span>
      <span class="body-small-emphasized">
        {{ totaleAssegniSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
      </span>
    </div>
  </div>

  <div class="selected-receipts-summary-divider"></div>

  <div class="selected-receipts-summary-bottom">
    <div class="selected-receipts-summary-row">
      <span class="body-large">{{ 'receipts.ui.totaleComplessivo2' | transloco }}</span>
      <span class="body-small-emphasized">
        {{ totaleBrogliacciSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
      </span>
    </div>
  </div>
</div>

<div class="new-draft-actions">
  <button
    matButton="filled"
    type="button"
    *uiCan="CAPS.distintaCrea"
    [disabled]="!almenoUnBrogliaccioIncluso || isSaving"
    (click)="creaDistinta()"
  >
    {{ 'receipts.ui.creaDistinta' | transloco }}
  </button>
</div>
}
